import { render } from "./RequestDetails.vue?vue&type=template&id=3d24fa12&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&lang=js"
export * from "./RequestDetails.vue?vue&type=script&lang=js"

import "./RequestDetails.vue?vue&type=style&index=0&id=3d24fa12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d24fa12"]])

export default __exports__